import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_ADSENSE_TRANSACTIONS,
  FETCH_ADSENSE_TRANSACTIONS_ERROR,
  CLEAR_ADSENSE_TRANSACTIONS,
} from 'redux/earnings/types';

export const fetchUserAdsenseTransactions = userId => baseErrorsHandlerDecorator(
  FETCH_ADSENSE_TRANSACTIONS,
  FETCH_ADSENSE_TRANSACTIONS_ERROR,
  () => restapi.get(addLang(`earn/user/${userId}/stats/`)),
  false,
);

export const clearUserAdsenseTransactions = () => dispatch => {
  dispatch({
    type: CLEAR_ADSENSE_TRANSACTIONS,
  });
};
